// @core/api/endpoints/analytics/list_saved_queries.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSavedQueriesResponse,
} from '../../../types/analytics';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/analytics';

/**
 * List saved queries
 * Returns saved analytics queries owned by or shared with the current user.
 */
export async function ListSavedQueries(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSavedQueriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/saved-queries`;
  const requestOptions = options;
  return client.get<ListSavedQueriesResponse>(requestPath, { ...requestOptions, params });
}
